"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canMoveToPreviousMonth = exports.canMoveToNextMonth = void 0;
var _add = _interopRequireDefault(require("date-fns/add"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
const canMoveToPreviousMonth = (activeDate, minDate) => {
  if (!minDate) {
    return true;
  }
  const prevMonthDate = (0, _sub.default)(activeDate, {
    months: 1
  });
  return prevMonthDate.getFullYear() >= activeDate.getFullYear();
};
exports.canMoveToPreviousMonth = canMoveToPreviousMonth;
const canMoveToNextMonth = (activeDate, maxDate) => {
  if (!maxDate) {
    return true;
  }
  const nextMonthDate = (0, _add.default)(activeDate, {
    months: 1
  });
  return nextMonthDate.getFullYear() <= activeDate.getFullYear();
};
exports.canMoveToNextMonth = canMoveToNextMonth;
//# sourceMappingURL=datePickerFrameUtil.js.map